"use client";

import type React from "react";
import { useState } from "react";

import { isUndefinedOrNull } from "@daytrip/utils";

export type SelectOption = {
    label: string;
    value: string | number;
    disabled?: boolean;
    [property: string]: any;
};

export interface DropdownOption {
    content: SelectOption;
    isFocused: boolean;
    onSelect: () => void;
    optionRenderer?: (option: SelectOption) => React.ReactNode;
}

export function useDropdownArrowKeysNavigation(
    isReadOnly?: boolean,
    hasArrowKeysNavigation?: boolean,
    options?: Array<SelectOption>,
    onSelect?: (option: SelectOption) => void,
    handleOpen?: (isOpen: boolean) => void,
) {
    const [focused, setFocused] = useState<number>();

    const setFocusedOption = (isDown: boolean = true) => {
        if (isUndefinedOrNull(focused)) {
            if (isDown) {
                setFocused(0);
            }
        } else if (isDown && options && options.length && options.length > focused + 1) {
            setFocused(focused + 1);
        } else if (isDown && options && options.length && options.length === focused + 1) {
            setFocused(0);
        } else {
            setFocused(focused - 1 < 0 ? undefined : focused - 1);
        }
    };

    const handleArrowNavigation = (event: React.KeyboardEvent<HTMLDivElement>) => {
        if (hasArrowKeysNavigation && !isReadOnly) {
            if (event.key === "ArrowUp") {
                event.preventDefault();
                setFocusedOption(false);
            } else if (event.key === "ArrowDown") {
                event.preventDefault();
                setFocusedOption();
            } else if (event.key === "Enter") {
                event.preventDefault();
                const selectedOption = focused || 0;

                if (options && options.length && options.length > selectedOption) {
                    if (onSelect) {
                        onSelect(options[selectedOption]);
                    }
                    if (handleOpen) {
                        handleOpen(false);
                    }
                }
            }
        }
    };

    return {
        focused,
        setFocused,
        handleArrowNavigation,
    };
}
